export default __webpack_public_path__ + "static/leandro-39e5ff1d22d79e35dba9dd5d6cc1192c.jpg";